import BaseFilter from "./base_filter"
import { createFormGroup, createSelect } from "./dom"

export default class DayOfWeekFilter extends BaseFilter {
  createForm() {
    super.createForm()

    const options = this.context.translations.weekdays.map((label, index) => ({
      label,
      value: index + 1,
    }))
    this.input = createSelect(options)
    this.element.append(createFormGroup(this.definition.title, this.input))
    this.appendApplyButton()

    return this.element
  }

  read() { return this.result(this.input.value, this.input.value !== "0") }

  summary(value) {
    const label = this.context.translations.weekdays[Number(value) - 1] || value
    return document.createTextNode(label)
  }
}
